import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const mediaSrc = (url) => {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  return `${BACKEND_URL}${url}`;
};

// Resolves both preset artwork (served by the frontend at /assets/...) and
// uploaded media (served by the backend at /api/media/...).
export const esSrc = (url) => {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:") || url.startsWith("/assets/")) return url;
  return `${BACKEND_URL}${url}`;
};

export default api;
